import { create as v } from "zustand";
import { QueryClient as I } from "@tanstack/react-query";
const S = (e) => ({
  ...e,
  username: "",
  isLoading: !1,
  error: null,
  isSuperAdmin: !1
}), h = () => ({
  ...S({ loggedIn: !1 }),
  profile: void 0,
  session: void 0,
  access: void 0
}), z = v((e) => ({
  // Initialize with logged out state
  ...h(),
  setLoggedIn: (t) => {
    e((n) => n.loggedIn === t ? n : t ? { loggedIn: !0 } : h());
  },
  setLoading: (t) => {
    e({ isLoading: t });
  },
  setError: (t) => {
    e({ error: t });
  },
  setProfile: (t) => {
    e({
      profile: t,
      username: t.username || "",
      loggedIn: !0,
      isSuperAdmin: t.is_super_admin ?? !1
    });
  },
  setSession: (t) => {
    e({ session: t });
  },
  setAccess: (t) => {
    e({ access: t });
  },
  setAuthData: (t, n, r) => {
    e({
      profile: t,
      session: n,
      access: r,
      username: t.username || "",
      loggedIn: !0,
      isLoading: !1,
      error: null,
      isSuperAdmin: t.is_super_admin ?? !1
    });
  },
  clearAuth: () => {
    e(h());
  },
  setIsSuperAdmin: (t) => {
    e({ isSuperAdmin: t });
  }
})), m = "NEU_CLIENT", A = "neu-client-change", O = "web", w = "pbm-portal";
function C() {
  return O;
}
function U() {
  var e;
  if (typeof window < "u") {
    const t = (e = window.localStorage.getItem(m)) == null ? void 0 : e.trim();
    if (t)
      return t.toLowerCase();
  }
  return C();
}
function _(e) {
  if (typeof window > "u")
    return;
  const t = e.trim().toLowerCase();
  window.localStorage.setItem(m, t), window.dispatchEvent(new Event(A));
}
function G() {
  typeof window > "u" || (window.localStorage.removeItem(m), window.dispatchEvent(new Event(A)));
}
function p(e) {
  return e === w ? "/pbm-portal/patient" : "/dashboard";
}
function L(e, t) {
  const n = t == null ? void 0 : t.trim();
  return e === w ? n != null && n.startsWith("/pbm-portal") ? n : p(e) : n && !n.startsWith("/pbm-portal") ? n : p(e);
}
function q(e) {
  return /^\/auth\/(access|refresh)(\/|$|\?)/.test(e);
}
function R(e) {
  return /^\/auth\/(login|twofa\/verify)(\/|$|\?)/.test(e);
}
function j(e) {
  const t = e.match(/\/api(\/[^?]*)/), n = (t == null ? void 0 : t[1]) ?? e;
  return q(n) ? {} : R(n) ? { "X-Neu-Client": C() } : { "X-Neu-Client": U() };
}
function M(e) {
  if (typeof window > "u" || !(e != null && e.neuAuthClient))
    return !1;
  _(e.neuAuthClient);
  const t = L(
    e.neuAuthClient,
    e.postLoginPath
  ), n = window.location.pathname;
  return e.neuAuthClient === w ? n.startsWith("/pbm-portal") ? !1 : (window.location.replace(t), !0) : n.startsWith("/pbm-portal") ? (window.location.replace("/dashboard"), !0) : n === "/" || n === "" ? (window.location.replace(t), !0) : !1;
}
function V(e, t) {
  if (!e) return t;
  const n = e.match(/filename\*=UTF-8''([^;\s]+)/i);
  if (n != null && n[1])
    try {
      return decodeURIComponent(n[1]);
    } catch {
      return t;
    }
  const r = e.match(/filename="([^"]+)"/i);
  if (r != null && r[1]) return r[1];
  const s = e.match(/filename=([^;\s]+)/i);
  return s != null && s[1] ? s[1].replace(/^"+|"+$/g, "") : t;
}
function P(e, t) {
  if (e && e !== "auto")
    return e;
  const n = (t == null ? void 0 : t.toLowerCase()) ?? "";
  return n.includes("application/pdf") || n.includes("application/octet-stream") ? "blob" : n.includes("json") ? "json" : "text";
}
function k(e = {}) {
  if (e.query)
    return e.query;
  const t = [];
  if (typeof e.page == "number" && t.push(`page=${e.page}`), typeof e.limit == "number" && t.push(`limit=${e.limit}`), typeof e.skip == "number" && t.push(`skip=${e.skip}`), e.sort && t.push(
    `sort=${encodeURIComponent(
      Array.isArray(e.sort) ? e.sort.join(",") : e.sort
    )}`
  ), e.fields && t.push(
    `fields=${encodeURIComponent(
      Array.isArray(e.fields) ? e.fields.join(",") : e.fields
    )}`
  ), Array.isArray(e.filters))
    for (const n of e.filters)
      n.field === void 0 || n.field === null || n.field === "" || t.push(
        `_${n.field}=${n.operator}:${encodeURIComponent(String(n.value))}`
      );
  else if (e.filters)
    for (const [n, r] of Object.entries(e.filters))
      r == null || r === "" || t.push(`_${n}=${encodeURIComponent(String(r))}`);
  return t.join("&");
}
const g = {
  cache: "no-store",
  headers: {
    "X-Client": "@neu/libui"
  }
}, E = {
  credentials: "include",
  headers: {
    "Content-Type": "application/json"
  }
};
function B() {
  try {
    return typeof window < "u" ? window.localStorage.getItem("AUTH_TOKEN") : null;
  } catch {
    return null;
  }
}
function H(e) {
  if (!e)
    return {};
  if (Array.isArray(e))
    return Object.fromEntries(e);
  if (e instanceof Headers) {
    const t = {};
    return e.forEach((n, r) => {
      t[r] = n;
    }), t;
  }
  return e;
}
function x(e) {
  const t = e.filter(Boolean);
  if (t.length === 0)
    return;
  if (t.length === 1)
    return t[0];
  const n = new AbortController(), r = () => {
    n.abort();
  };
  for (const s of t) {
    if (s.aborted) {
      n.abort();
      break;
    }
    s.addEventListener("abort", r, { once: !0 });
  }
  return n.signal;
}
function f(e) {
  return `/api${e.startsWith("/") ? e : `/${e}`}`;
}
async function c(e, t) {
  const { timeoutMs: n, parseAs: r = "auto", ...s } = t || {}, l = B(), $ = {
    ...E.headers,
    ...H(s.headers),
    ...l ? { Authorization: `Bearer ${l}` } : {},
    ...g.headers,
    ...j(e)
  };
  let a, d;
  typeof n == "number" && n > 0 && (a = new AbortController(), d = setTimeout(() => a == null ? void 0 : a.abort(), n));
  const T = x([
    s.signal ?? void 0,
    a == null ? void 0 : a.signal
  ]);
  try {
    const i = await fetch(e, {
      ...E,
      ...s,
      ...g,
      headers: $,
      signal: T
    });
    if (!i.ok) {
      const o = new Error(`HTTP ${i.status}`);
      throw o.response = i, o.status = i.status, o.info = `${e}: ${await i.text()}`, o.message || (o.message = o.info || `HTTP ${i.status}`), o;
    }
    const u = i.headers.get("content-type"), N = i.headers.get("Content-Disposition"), b = P(r, u);
    if (b === "blob")
      return {
        blob: await i.blob(),
        contentType: u,
        contentDisposition: N
      };
    const y = await i.text();
    return b === "json" ? y ? JSON.parse(y) : null : y;
  } catch (i) {
    if (i instanceof DOMException && i.name === "AbortError") {
      const u = new Error(
        n ? `Request timed out after ${n}ms` : "Request aborted"
      );
      throw u.status = 0, u;
    }
    throw i;
  } finally {
    d && clearTimeout(d);
  }
}
const Y = c;
async function W(e, t, n) {
  return c(f(`/${e}/${t}`), n);
}
function F(e, t) {
  return t ? `/${e}/list?${t}` : `/${e}/list`;
}
async function Z(e, t, n) {
  const r = k(t ?? {}), l = ((t == null ? void 0 : t.buildBaseListUrl) ?? F)(e, r);
  return c(f(l), n);
}
const K = {
  root: ["api"],
  path: (e, t) => ["api", "path", e, t ?? null],
  entityRoot: (e) => ["api", "entity", e],
  entityList: (e, t) => ["api", "entity", e, "list", t],
  entity: (e, t) => ["api", "entity", e, "detail", t]
};
function D(e) {
  var t, n;
  return new I({
    ...e,
    defaultOptions: {
      queries: {
        staleTime: 0,
        gcTime: 300 * 1e3,
        retry: !1,
        refetchOnWindowFocus: !1,
        refetchOnReconnect: !1,
        ...(t = e == null ? void 0 : e.defaultOptions) == null ? void 0 : t.queries
      },
      mutations: {
        retry: !1,
        ...(n = e == null ? void 0 : e.defaultOptions) == null ? void 0 : n.mutations
      }
    }
  });
}
const Q = D();
async function ee(e, t, n) {
  const r = (n == null ? void 0 : n.queryKey) ?? K.entity(e, t);
  return Q.fetchQuery({
    queryKey: r,
    staleTime: n == null ? void 0 : n.staleTime,
    queryFn: () => W(e, t, n == null ? void 0 : n.fetchOptions)
  });
}
async function te(e, t, n) {
  return c(f(`/${e}/save`), {
    ...n,
    method: "POST",
    body: JSON.stringify(t)
  });
}
async function ne(e, t, n, r) {
  return c(f(`/${e}/${n}`), {
    ...r,
    method: "PUT",
    body: JSON.stringify(t)
  });
}
export {
  A as N,
  E as a,
  k as b,
  f as c,
  c as d,
  Y as e,
  g as f,
  B as g,
  W as h,
  Z as i,
  D as j,
  Q as k,
  ee as l,
  te as m,
  M as n,
  G as o,
  C as p,
  K as q,
  U as r,
  V as s,
  j as t,
  ne as u,
  w as v,
  m as w,
  O as x,
  _ as y,
  z
};
